import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';

import mock from './mock';
import request from "@/utils/request";
import axios from "axios";
//svg
import '@/assets/icons/index.js';
import SvgIcon from '@/components/SvgIcon.vue';
Vue.component('SvgIcon', SvgIcon)

//utils
import {isCs} from "@/utils/utils"
Vue.prototype.$isCs=isCs

// element ui
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);

import '@/assets/style/index.less';

Vue.config.productionTip = false

// 测试地址
const testUrl = [
  "http://localhost:8080", // 0
  "http://192.168.50.215:8089", // 1
  "https://bj38540497.picp.vip/api", // 2
];

axios.defaults.baseURL = testUrl[0];
Vue.prototype.$http = axios;

const startApp = function() {
  request({ url: "server.json", method: "get" }).then(data => {
    request.defaults.baseURL = data.baseURL;
    Vue.prototype.$baseURL = data.baseURL;
    Vue.prototype.$imAPI = data.imAPI;
    Vue.prototype.$resUrl= data.resUrl;
    // Vue.prototype.$allocationApi = data.allocationApi;
    // Vue.prototype.$imBaseURL = data.imBaseURL;
    Vue.prototype.$authUrl = data.authUrl;
    Vue.prototype.$socket = data.socket;
    Vue.prototype.$wsUrl = data.wsUrl;
    global.$wsUrl = data.wsUrl;
    window.$wsUrl = data.wsUrl;
    new Vue({
      router,
      store,
      mock,
      render: function (h) {
        return h(App)
      }
    }).$mount('#app')
  });
};
startApp();